export function displayInitialCustomerPartNumber() {
  const selectedUom = document.querySelector('.uom-picker-button.selected')
  if (!selectedUom) return
  
  updatePartNumberDisplay(selectedUom)
}

export function updateCustomerPartNumber() {
  const selectedUom = document.querySelector('.uom-picker-button.selected')
  if (!selectedUom) return
  
  updatePartNumberDisplay(selectedUom)
}

function updatePartNumberDisplay(uomButton) {
  const partNumber = uomButton.dataset.partNumber
  const customerPartNumber = uomButton.dataset.customerPartNumber
  
  updateTechflexPartNumber(partNumber)
  updateCrossReferencePartNumber(partNumber, customerPartNumber)
}

function updateTechflexPartNumber(partNumber) {
  const element = document.querySelector('.techflex-part-number')
  if (element && partNumber) {
    element.textContent = `(${partNumber})`
  }
}

function updateCrossReferencePartNumber(partNumber, customerPartNumber) {
  const element = document.querySelector('.customer-part-number')
  if (!element) return
  
  if (shouldShowCrossReference(partNumber, customerPartNumber)) {
    element.textContent = ` - Cross Reference: ${customerPartNumber}`
  } else {
    element.textContent = ''
  }
}

function shouldShowCrossReference(partNumber, customerPartNumber) {
  if (!customerPartNumber) return false
  
  const cleanPartNumber = cleanString(partNumber)
  const cleanCustomerPartNumber = cleanString(customerPartNumber)
  
  return cleanCustomerPartNumber !== cleanPartNumber
}

function cleanString(str) {
  return str ? String(str).replace(/[^a-zA-Z0-9.]/g, '') : ''
}
